// extracted by mini-css-extract-plugin
module.exports = {"root":"TemperatureInputField_root__aan2J"};